// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

import { ArchivingImportTypeEnum } from '@app/modules/archiving/models/archiving-import.model';

export class ArchivingExportItemTMO {
	created?: Date = undefined;
	createdBy?: string = undefined;
	exportId?: string = undefined;
	failures?: ArchivingFailure[] = undefined;
	id?: string = undefined;
	importId?: string = undefined;
	importType?: ArchivingImportTypeEnum = undefined;
	importTypeVersion?: string = undefined;
	lastModifiedBy?: string = undefined;
	lastModified?: Date = undefined;
	processingState?: ArchivingExportItemStatusEnum = undefined;
	processingStep?: ArchivingExportItemStepEnum = undefined;
	title?: string = undefined;
}

export class ArchivingFailureTMO {
	identifier?: string = undefined;
	type?: ArchivingFailureTypeEnum = undefined;
	message?: string = undefined;
	code?: ArchivingFailureCodeEnum = undefined;
	created?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingExportItem extends ArchivingExportItemTMO {}

export class ArchivingFailure extends ArchivingFailureTMO {}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************

export enum ArchivingExportItemStepEnum {
	NEW = 'NEW',
	TIER_CHANGE = 'TIER_CHANGE',
	TIER_CHANGE_DONE = 'TIER_CHANGE_DONE',
	COPY = 'COPY',
	COPY_DONE = 'COPY_DONE',
	DSFINVK_TRANSFORMATION = 'DSFINVK_TRANSFORMATION',
	DSFINVK_TRANSFORMATION_DONE = 'DSFINVK_TRANSFORMATION_DONE'
}

export enum ArchivingExportItemStatusEnum {
	PENDING = 'PENDING',
	READY = 'READY',
	CANCELLED = 'CANCELLED',
	ERROR = 'ERROR'
}

export enum ArchivingFailureTypeEnum {
	EXPORT_ITEM = 'EXPORT_ITEM'
}

export enum ArchivingFailureCodeEnum {
	GENERAL_ERROR = 'GENERAL_ERROR',
	COPY_ERROR = 'COPY_ERROR',
	REHYDRATION_ERROR = 'REHYDRATION_ERROR',
	VALIDATION_ERROR = 'VALIDATION_ERROR',
	VALIDATION_ERROR_INVALID_STATE = 'VALIDATION_ERROR_INVALID_STATE'
}

// UI enums *********************************************************

export enum ArchivingExportCategoryEnum {
	IMPORT = 'import',
	OPEN_ARCHIVE = 'openArchive',
	PROCEDURAL_DOCUMENTATION = 'proceduralDocumentation',
	TSS_LOG = 'tssLog'
}
